import React from 'react';
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { sortBy, without } from "lodash";
import styled from 'styled-components';
import { ToastError } from "components/Global/Toasts/Toasty";
import { ButtonText, COMPANY_TYPES } from '@loanbossinc/component-library';
import { getCompanies, getCompany, modifyCompanySponsors } from "./companySponsors.store";
import { getCompaniesByTypeId } from 'store/state/companies';
import CompaniesGrid from "./companiesGrid";
import CompanySponsors from './companySponsors';


const PageHeader = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;

    color: #000000;
    margin-bottom: 80px;
    margin-left: 30px;
    
    width: 956px;
`;

const StyledButtonText = styled(ButtonText)`
  && {
    display: flex;
    flex: 2;
    width: 100%;
    justify-content: 'flex-start';
    .label {
      margin-left: 14px;
    }
  }
`;

class CompanySponsorsIndex extends React.Component {
    state = {
        selectedCompanyId: null,
        selectedCompany: null,
        dropdownCompanyId: null,
    }

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this.props.getCompanies();
        this.props.getCompaniesByTypeId({ subKey: 'sponsor', companyTypeId: COMPANY_TYPES.SPONSOR });
    }

    componentDidUpdate(prevProps, prevState) {

    }

    openEdit = (id) => {
        const { companies } = this.props;
        const company = companies.find(x => x.id === id);
        this.setState({
            selectedCompanyId: id,
            selectedCompany: company
        });
    };

    clearSelection = () => {
        this.setState({ selectedCompanyId: null })
    };

    handleCompanySelect = (companyId) => {
        this.setState({ dropdownCompanyId: companyId });
    };

    removeSponsorCompany = (removedId) => {
        const { selectedCompanyId, selectedCompany } = this.state;
        const sponsorCompanyIds = selectedCompany.sponsorCompanies.filter(x => x.id !== removedId).map(x => x.id);
        this.props.modifyCompanySponsors({ companyId: selectedCompanyId, sponsorCompanyIds, callback: () => this.openEdit(selectedCompanyId) });
    };

    addCompany = () => {
        const { selectedCompanyId, selectedCompany, dropdownCompanyId } = this.state;
        if (dropdownCompanyId) {
            const sponsorCompanyIds = selectedCompany.sponsorCompanies.map(x => x.id);
            sponsorCompanyIds.push(dropdownCompanyId);
            this.props.modifyCompanySponsors({ companyId: selectedCompanyId, sponsorCompanyIds, callback: () => this.openEdit(selectedCompanyId) });
        } else {
            ToastError("Please select a company to add");
        }
    };

    getFilteredSponsors = () => {
        const { selectedCompanyId, selectedCompany } = this.state;
        const { allCompanies } = this.props;
        return selectedCompany && selectedCompany.sponsorCompanies.length > 0 &&
                allCompanies && allCompanies.length > 0
                ?
                allCompanies.filter(x => !selectedCompany.sponsorCompanies.some(s => s.id === x.id) && x.id !== selectedCompanyId)
                :
                allCompanies && allCompanies.length > 0 ? 
                                                        allCompanies.filter(x => x.id !== selectedCompanyId) 
                                                        :
                                                        [];
    };

    render() {
        const { selectedCompanyId, selectedCompany } = this.state;
        const { companies } = this.props;
        if(!companies) return null;

        const sortedCompanies = sortBy(companies, [ 'name' ]);
        const headerMessage = `Broker Company Settings ${selectedCompanyId ? ' - Authorized Sponsor Settings' : ''}`;

        const filteredSponsors = this.getFilteredSponsors();

        if (selectedCompany && selectedCompany.sponsorCompanies) {
            selectedCompany.sponsorCompanies = sortBy(selectedCompany.sponsorCompanies, [ 'name' ]);
        }

        return (
            <>

                <PageHeader>
                    {headerMessage}
                    {selectedCompanyId && <StyledButtonText
                        label={"Back"}
                        iconName={'arrow_forward'}
                        onClick={this.clearSelection}
                        reverse={true} />}
                </PageHeader>

                {!selectedCompanyId && <CompaniesGrid
                    companies={sortedCompanies}
                    onClick={(id) => this.openEdit(id)}
                />}
                {selectedCompanyId &&
                    <CompanySponsors
                        selectedCompanyId={selectedCompanyId}
                        company={selectedCompany}
                        sponsorCompanies={filteredSponsors}
                        addCompany={this.addCompany}
                        removeCompany={this.removeSponsorCompany}
                        handleCompanySelect={this.handleCompanySelect}
                    />}
            </>
        );

    }
}

const mapStateToProps = ({ companySponsor, authentication, companies }) => {
    const allCompanies = sortBy(companies.companiesByTypeId.sponsor, [ 'name' ]);
    return ({
        authentication,
        ...companySponsor,
        allCompanies
    })
};

export default compose(
    withRouter,
    connect(mapStateToProps, {
        getCompanies,
        getCompany,
        modifyCompanySponsors,
        getCompaniesByTypeId,
    }))(CompanySponsorsIndex);